import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const DownloadIcon = ({ color = '#B5BCBD', size = '24', ...props }) => (
  <svg
    width={size}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.438 0h3.124c.52 0 .938.418.938.938V7.5h3.426a.78.78 0 0 1 .55 1.332l-5.94 5.945a.757.757 0 0 1-1.067 0l-5.95-5.945A.78.78 0 0 1 4.07 7.5H7.5V.937C7.5.418 7.918 0 8.438 0zM20 14.688v4.374c0 .52-.418.938-.938.938H.938A.935.935 0 0 1 0 19.062v-4.375c0-.519.418-.937.938-.937h5.73l1.914 1.914c.785.785 2.05.785 2.836 0l1.914-1.914h5.73c.52 0 .938.418.938.938zm-4.844 3.437a.784.784 0 0 0-.781-.781.784.784 0 0 0-.781.781c0 .43.351.781.781.781.43 0 .781-.351.781-.781zm2.5 0a.784.784 0 0 0-.781-.781.784.784 0 0 0-.781.781c0 .43.351.781.781.781.43 0 .781-.351.781-.781z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

DownloadIcon.propTypes = propTypes;

export default DownloadIcon;
